module.exports = "/images/vendor/flag-icon-css/flags/4x3/bl.svg?38e27b684c0a7f079cc7e1762e5e1ade";